export const TOAST_MESSAGES = {
  SAN_FETCH_FAILED: "Failed to fetch Materials.",
  SAN_CREATE_FAILED: "Failed to create SAN",
  SAN_UPDATE_FAILED: "Failed to update Material Requisition.",
  SAN_SUCCESS: "SAN created successfully!",
  SAN_ALREADY_ADDED: "This product is already added!",
  SAN_NO_DATA: "No Details Available",
  SAN_DELETE: "SAN Deleted Successfully",
  FAILED_TO_DELETE_SAN: "Failed to delete SAN",
  FAILED_TO_FETCH_WAREHOUSES: "Failed to fetch warehouses!",
  UPDATE_SAN_SUCCESS: "SAN Updated Successfully",
  UPDATE_SAN_FAILED: "Failed to update SAN",
  UPDATE_SAN_STATUS_FAILED: "Failed to update SAN status",
  UPDATE_SAN_STATUS_ERROR: "Error updating status. Please try again.",
};

export const MATERIAL_COLUMNS = [
  "receiving_warehouse_name",
  "status",
  "created",
  "created_by",
  "actions",
];

export const MATERIAL_LABELS = {
  receiving_warehouse_name: "Receiving Warehouse",
  status: "Status",
  created: "Raised On",
  created_by: "Adjusted By",
  actions: "Actions",
};

export const SAN_STATUS_VALUE_LABELS = [
  { value: "DRAFT", label: "Draft" },
  { value: "PENDING_FOR_APPROVAL", label: "Pending for Approval" },
{ value: "APPROVED", label: "Approved" },
{ value: "REJECTED", label: "Rejected" },
];

export const SAN_STATUS = {
  DRAFT: "DRAFT",
  PENDING_FOR_APPROVAL: "PENDING_FOR_APPROVAL", 
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

// helper.js or constants.js

export const getSANStatusColor = (status) => {
  switch (status) {
    case SAN_STATUS.DRAFT:
      return "bg-gray-100 hover:bg-gray-200 transition-colors text-gray-700";
    case SAN_STATUS.PENDING_FOR_APPROVAL:
      return "bg-green-50 hover:bg-green-150 transition-colors text-green-500";
    case SAN_STATUS.APPROVED:
      return "bg-blue-50 hover:bg-blue-100 transition-colors text-blue-500";
    case SAN_STATUS.REJECTED:
      return "bg-red-50 hover:bg-red-100 transition-colors text-red-500";
    default:
      return "bg-white transition-colors text-black"; // fallback for unknown status
  }
};

export const MATERIAL_COLUMNS_SAN = [
  "product_name",
  "available_quantity",
  "quantity",
  "note",
  "actions",
];
export const MATERIAL_LABELS_SAN = {
  product_name: "Material",
  note: "Note",
  available_quantity:"Available Quantity",
  quantity: "Manage Quantity",
  actions: "Action",
};

export const ROLES = {
  PROJECT_MANAGER: "PROJECT_MANAGER",
  SITE_ENGINEER: "SITE_ENGINEER",
  INVENTORY_INCHARGE: "INVENTORY_INCHARGE",
  INVENTORY_ADMIN: "INVENTORY_ADMIN",
};